export enum Browsers {
  Chrome = 'Chrome',
  Firefox = 'Firefox',
  Safari = 'Safari',
  MobileSafari = 'Mobile Safari',
  Edge = 'Edge',
  AndroidBrowser = 'Android Browser',
}
